import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from './index'
import type { IClientUID } from '../clients'

export async function monitorClient(clientId: IClientUID, monitor: boolean): Promise<ApiResponse<null>> {
    const response = await fetch(`${HOST_URL}monitored-client`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, monitor }),
    })
    const result = (await response.json()) as ApiResponse<null>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function isClientMonitored(clientId: IClientUID): Promise<ApiResponse<boolean>> {
    const response = await fetch(`${HOST_URL}monitored-client/is-monitored`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<boolean>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
